import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProjectSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-header {
    padding-left: 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
    .form-header-right {
      text-align: right;
      .MuiButton-root {
        height: auto;
        padding-left: 4px;

        svg {
          margin-right: 10px;
        }
      }
    }

    ${responsive.MOBILE`
        justify-content: space-between;
        align-items: center;
      `};
  }
  .form-container {
    padding: 0px 0px 16px 16px;
    ${responsive.MOBILE`
      padding: 0px 0px 16px 8px;
    `}
  }

  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    gap: 16px;
    margin-right: 16px;
    margin-top: 40px;
    ${responsive.MOBILE`
      flex-direction:column-reverse;
      display:flex;
      margin-top: 0px;
      margin-right: 8px;
      margin-left: 8px;
      padding-bottom: 16px;
    `}
    button {
      ${responsive.MOBILE`
        width:100%;
      `}
    }
  }
  .padding-horizontal {
    ${responsive.MOBILE`
      margin: 0px 8px;
    `}
  }
  .MuiGrid2-root {
    padding-right: 16px;
    ${responsive.MOBILE`
      padding-right: 8px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
  }

  .confirm-message {
    line-height: 20px;
    margin-bottom: 8px;
    color: ${COLORS.cirrus_black10};
  }

  .item-name {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .reset-all-button {
    margin-right: 38px;
  }
`;
